import DisplayComponent from './DisplayComponent';

export { DisplayComponent };
